import {
  JobCompanyInfoResponse,
  JobResponse,
} from '@doda/api-client/aspida/@types';
import { Text } from '@doda/io-react/common';
import { TextWithLF } from '@doda/common/src/components/TextWithLF';
import styles from './index.module.scss';

/**
 * RequirementHeadのprops
 */
export interface Props {
  companyInfo: JobCompanyInfoResponse;
  corporateFullName: string;
  occupationName: JobResponse['occupationName'];
}

/**
 * 求人概要
 */
export const RequirementHead = ({
  companyInfo,
  corporateFullName,
  occupationName,
}: Props) => {
  const {
    companyOverviewHeading,
    companyOverviewSubHeading,
    companyOverviewText,
    companyOverviewImage,
  } = companyInfo;
  return (
    <div className={styles['jobSearchDetail-requirementHead']}>
      <h2 className={styles['jobSearchDetail-requirementHead__title']}>
        <Text
          size="20"
          as="span"
          weight="bold"
          className={styles['jobSearchDetail-requirementHead__underline']}
        >
          {companyOverviewHeading}
          <br />
          {companyOverviewSubHeading}
        </Text>
      </h2>
      <div className={styles['jobSearchDetail-requirementHead__contents']}>
        <Text
          size="14--articlePC"
          as="p"
          className={styles['jobSearchDetail-requirementHead__left']}
        >
          <TextWithLF text={companyOverviewText || ''} />
        </Text>
        <img
          src={companyOverviewImage}
          alt={`${corporateFullName} ${occupationName}`}
          className={styles['jobSearchDetail-requirementHead__right']}
        />
      </div>
    </div>
  );
};
